module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_GA-e24a2b746779d9e293c0ae244b5423f8.svg";